import { SiteIntegration } from "~/api/Api";

export type IntegrationGap = {
  kind: SiteIntegration["kind"];
  name: string;
  /** What the report leaves out without the integration. */
  data: string;
  reason: "not_connected" | "no_property";
};

const REPORT_INTEGRATIONS: Omit<IntegrationGap, "reason">[] = [
  {
    kind: "google_search_console",
    name: "Search Console",
    data: "search clicks, impressions and queries",
  },
  {
    kind: "google_analytics",
    name: "Google Analytics",
    data: "organic traffic and AI assistant referrals",
  },
];

// Mirrors ClientReport::SearchConsole and ClientReport::Analytics: a section
// is left out unless the site's integration of its kind has a property
// selected. Revoked Google access only shows up when the report is made.
export const findIntegrationGaps = (
  integrations: SiteIntegration[],
): IntegrationGap[] =>
  REPORT_INTEGRATIONS.flatMap((item): IntegrationGap[] => {
    const integration = integrations.find(({ kind }) => kind === item.kind);

    if (!integration) return [{ ...item, reason: "not_connected" }];
    if (!integration.properties?.length) {
      return [{ ...item, reason: "no_property" }];
    }

    return [];
  });
